import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChecklistItemIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20.5829 10.2114L22 11.6514L15.3486 18.3486L11.0286 14.0514L12.4457 12.6343L15.3486 15.4914L20.5829 10.2114ZM2 14.5086V12.6343H9.58857V14.5086H2ZM13.4286 5V6.92H2V5H13.4286ZM13.4286 8.79429V10.7143H2V8.79429H13.4286Z'
                fill='currentColor'
            />
        </>
    ),
})

ChecklistItemIcon.displayName = 'ChecklistItemIcon'
